import { render, staticRenderFns } from "./viewDoc.vue?vue&type=template&id=def5a412&scoped=true&"
import script from "./viewDoc.vue?vue&type=script&lang=js&"
export * from "./viewDoc.vue?vue&type=script&lang=js&"
import style0 from "./viewDoc.vue?vue&type=style&index=0&id=def5a412&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def5a412",
  null
  
)

export default component.exports